import $ from 'jquery'

$(document).on('click', "[data-behavior='sf-userlane-launcher']", (e) => {
  e.preventDefault()
  Userlane('openAssistant')
})
